import alerts from '../helpers/storeModuleHelpers/alerts';
import axios from 'axios';
import { BASE_URL } from '@/helpers/apiUtilities.js';

export const state = {
  data: [],
  loading: false,
  ...alerts.getState()
};

export const mutations = {
  ...alerts.mutations,
  setLoading: function (state, bool) {
    state.loading = bool;
  },
  setOrders: function (state, orders) {
    state.data = orders;
  }
};

export const actions = {
  getOrders: function (store) {
    store.commit('setLoading', true);

    return axios.get(BASE_URL + '/ShopifyOrders')
      .then(response => {
        store.commit('setOrders', response.data);
        return response.data;
      })
      .catch((error) => {
        const alert = {
          alertGroup: 'orderHistory',
          status: 'error',
          message: 'Error getting orders:',
          error
        };
        store.commit('addAlert', alert);
      })
      .finally((response) => {
        store.commit('setLoading', false);
        return response;
      });
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
